import { User as BaseUser } from '@99designs/common/components/User';
import * as React from 'react';

export interface Designer {
    id: number;
    displayName: string;
}

interface Props {
    user: Designer;
    size: 'extra-small' | 'small';
}

const User = ({ user, size }: Props) => (
    <BaseUser
        user={{
            name: user.displayName,
            profileUrl: `/profiles/${user.id}`,
            avatarUrl: `/avatars/users/${user.id}/128`,
        }}
        avatarVariations={[size, 'white-border']}
        isLinked={false}
    />
);

export default User;
